import React, { createContext } from "react";

//defined in Main.js
const MainContext = createContext();

export default MainContext;
